import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IsLoadingHOC from "../../common/IsLoadingHOC";
import { authAxios } from "../../config/config";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { formatBoldText,BlogsHelper } from "../../helper/helper";
import { setrefetch } from "../../Redux/Reducers/authSlice";

const StandardForm = ({ setLoading }) => {
  
const userName = useSelector((state) => state.auth.user.fname);
  const location = useLocation();
  const ids = location?.state?.id;
  const [formValues, setFormValues] = useState({
    Entrepreneurs_Full_Name: "",
    title: "story title",
    Business_Name: "",
    Location: "",
    Brief_Introduction_of_the_Entrepreneur: "",
    Brief_Introduction_of_the_Business: "",
    Motivation_Behind_the_Entrepreneurial_Journey: "",
    Challenges_Faced: "",
    Source_of_Referral_to_WeBC: "",
    Year_Joined_WeBC: "",
    WeBC_Program_Enrolled: "",
    Impact_of_WeBC_Program: "",
    Future_Goals: "",
    Quotes: "",
    Years_in_business  :"",
    Reason_of_joining :"",
    Pronouns:""
  });

  const dispatch = useDispatch()
  const [storyDetail, setstoryDetail] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
      title: formValues.Entrepreneurs_Full_Name,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const endpoint = editable ? 'stories/edit_multiform' : 'stories/submit_multiform';
    
    const payload = {
      formType: "Standard",
      selectedSet: "set1",
      ...(editable && { _id: storyId }), 
      answers: formValues,
    };
  
    try {
      const response = await authAxios().post(endpoint, payload);
      const resData = response?.data;
    if(resData?.status === 1){
      setstoryDetail(resData.data);
      dispatch(setrefetch("story"))
      toast.success(resData?.message);
      
      sessionStorage.removeItem("editable")
    }
    else{
      toast?.error(resData.message)
    }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  
  const storyId = sessionStorage.getItem("story_id");
  const editable = sessionStorage.getItem("editable");

  const fetchstory = async () => {
    setLoading(true);
    await authAxios()
      .post(`/stories/get_single_multi_storie`, { _id: storyId })
      .then((response) => {
        setLoading(false);
        const data = response?.data?.data;

        if (data && data.answers && data.answers.length > 0) {
          const answers = data.answers[0];
    
          setFormValues(prevValues => ({
            ...prevValues,
            ...answers,
          }));
        }
          setstoryDetail(data)
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };
  useEffect(() => {
    if(storyId ){
      fetchstory();
    }
  }, [storyId]);

  useEffect(() => {
    sessionStorage.removeItem("editable");
  }, []);
  
  return (
    <>
      <div className="h-full flex flex-col justify-between">
        <div>
          <style>
            {`
              .custom-scrollbar::-webkit-scrollbar {
                width: 10px;
              }
              .custom-scrollbar::-webkit-scrollbar-thumb {
                background: #fce7da;
                border-radius: 10px;
              }
            `}
          </style>

          <div
            className={`py-[20px] overflow-auto h-[calc(100vh-100px)] pb-[35px] custom-scrollbar`}
          >
            <div className="bg-[#FFE6D9] border-[2px] border-[#EE635B] p-[15px] rounded-[10px] flex items-center gap-5 max-w-[885px] w-full mx-auto mb-5">
              <div>
                <img
                  src="./assets/images/story-c.png"
                  alt="image"
                  className="w-[65px] aspect-square"
                  onClick={() => sessionStorage.removeItem("formType")}
                  style={{cursor:'pointer'}}
                />
              </div>
              <p className="text-[#2C2C2C] text-[20px] font-semibold">
                Write your story
              </p>
            </div>

            <div className="max-w-[885px] w-full mx-auto">
              <div className="bg-[#FFE6D9] rounded-t-[10px] min-h-[88px] text-center p-[20px] flex items-center justify-center border-b-[2px] border-b-[#fff]">
                <h1 className="text-[#000] lg:text-[40px] font-[600] text-[25px]">
                  Welcome <span className="capitalize">{userName}!</span>
                </h1>
              </div>

              <form
                onSubmit={handleSubmit}
                className="bg-[#FFE6D9] lg:p-[40px] p-[15px] lg:pb-[10px] rounded-b-[10px]"
              >
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurName"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Entrepreneur's Full Name<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="Entrepreneurs_Full_Name"
                      value={formValues.Entrepreneurs_Full_Name}
                      onChange={handleInputChange}
                      className={`min-h-[50px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                      disabled={storyDetail?.story && !editable}
                    />
                  </div>
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="location"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Location(City) <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="Location"
                      value={formValues.Location}
                      onChange={handleInputChange}
                      className={`min-h-[50px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <h3 className="mb-4 font-semibold text-gray-900 dark:text-white">
                  Preferred Personal Pronoun
                </h3>
                <ul className="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                  <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                    <div className="flex items-center ps-3">
                      <input
                        id="pronoun-she"
                        type="radio"
                        value="She/Her"
                        name="Pronouns"
                        checked={formValues?.Pronouns === "She/Her"}
                       disabled={storyDetail?.story && !editable}
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                        onChange={handleInputChange}
                      />
                      <label
                        htmlFor="pronoun-she"
                        className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >
                        She/Her
                      </label>
                    </div>
                  </li>
                  <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                    <div className="flex items-center ps-3">
                      <input
                        id="pronoun-he"
                        type="radio"
                        value="He/Him"
                        name="Pronouns"
                        checked={formValues?.Pronouns === "He/Him"}
                       disabled={storyDetail?.story && !editable}
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                        onChange={handleInputChange}
                      />
                      <label
                        htmlFor="pronoun-he"
                        className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >
                        He/Him
                      </label>
                    </div>
                  </li>
                  <li className="w-full dark:border-gray-600">
                    <div className="flex items-center ps-3">
                      <input
                        id="pronoun-they"
                        type="radio"
                        value="They/Them"
                        name="Pronouns"
                        checked={formValues?.Pronouns === "They/Them"}
                       disabled={storyDetail?.story && !editable}

                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                        onChange={handleInputChange}
                      />
                      <label
                        htmlFor="pronoun-they"
                        className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >
                        They/Them
                      </label>
                    </div>
                  </li>
                </ul>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="businessName"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Business Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="Business_Name"
                      value={formValues.Business_Name}
                      onChange={handleInputChange}
                      className={`min-h-[50px] rounded-[8px] p-[15px]  ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Years in Business {" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      name="Years_in_business"
                      value={formValues.Years_in_business}
                      onChange={handleInputChange}
                      className={`min-h-[50px] rounded-[8px] p-[15px]  ${storyDetail ? 'bg-white' : ''}`}
                     
                      // className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                     Entrepreneur's Background Information (Education/Previous Experience){" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Brief_Introduction_of_the_Entrepreneur"
                      value={formValues.Brief_Introduction_of_the_Entrepreneur}
                      onChange={handleInputChange}
                       className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="businessIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                    Business Startup Story{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Brief_Introduction_of_the_Business"
                      value={formValues.Brief_Introduction_of_the_Business}
                      onChange={handleInputChange}
                       className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="motivation"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                       Inspiration/Motivation
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Motivation_Behind_the_Entrepreneurial_Journey"
                      value={
                        formValues.Motivation_Behind_the_Entrepreneurial_Journey
                      }
                      onChange={handleInputChange}
                       className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="challenges"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Challenges Faced
                       <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Challenges_Faced"
                      value={formValues.Challenges_Faced}
                      onChange={handleInputChange}
                       className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="futureGoals"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Future Goals <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Future_Goals"
                      value={formValues.Future_Goals}
                      onChange={handleInputChange}
                       className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="quotes"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                     Business Quote<span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Quotes"
                      value={formValues.Quotes}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="referralSource"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                     How did you hear about WeBC? {" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Source_of_Referral_to_WeBC"
                      value={formValues.Source_of_Referral_to_WeBC}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="yearJoined"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Year Joined WeBC <span className="text-red-500">*</span>
                    </label>
                    <input
                      name="Year_Joined_WeBC"
                      value={formValues.Year_Joined_WeBC}
                      onChange={handleInputChange}
                      className={`min-h-[50px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                    Reason for Joining{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Reason_of_joining"
                      value={formValues.Reason_of_joining}
                      onChange={handleInputChange}
                       className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="programEnrolled"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                     Program(s) Used{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      name="WeBC_Program_Enrolled"
                      value={formValues.WeBC_Program_Enrolled}
                      onChange={handleInputChange}
                      className={`min-h-[50px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="programImpact"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                     Benefits Received from the Program{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Impact_of_WeBC_Program"
                      value={formValues.Impact_of_WeBC_Program}
                      onChange={handleInputChange}
                       className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                {storyDetail?.story ? (
                  <>
                  <div className="flex flex-col lg:flex-row gap-3 mb-3 bg-white p-5 rounded-[10px]">
                    <div className="w-full flex flex-col gap-y-[10px]">
                      
                      <div>
                        <p>
                  {BlogsHelper(storyDetail?.story) || ""}
                        </p>
                      </div>
                    </div>
                  </div>
                  {editable && 
                  <div className="flex justify-center py-3">
                    <button
                  type="submit"
                  className="bg-[#EE635B] text-[#FFFFFF] text-[16px] font-[600] rounded-[8px] py-[15px] px-[30px] min-w-[130px]"
                >
                   Regenerate
                </button>
                </div>}
                  </>
                ) : <div className="flex justify-center py-3">
                <button
                  type="submit"
                  className="bg-[#EE635B] text-[#FFFFFF] text-[16px] font-[600] rounded-[8px] py-[15px] px-[30px] min-w-[130px]"
                >
                  Submit
                </button>
              </div>}
                
                {/* <div className="flex justify-center py-3">
                  <button
                    type="submit"
                    className="bg-[#EE635B] text-[#FFFFFF] text-[16px] font-[600] rounded-[8px] py-[15px] px-[30px] min-w-[130px]"
                  >
                    Submit
                  </button>
                </div> */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IsLoadingHOC(StandardForm);
